import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const spotTradeSchema = z.object({
  /** Trade ID, e.g. "6300941147" */
  id: z.string(),
  /** Trading time in seconds, e.g. "1695864689" */
  create_time: z.string(),
  /** Trading time, with millisecond precision, e.g. "1695864689898.836000" */
  create_time_ms: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => Math.floor(Number.parseFloat(v))),
  /** Currency pair, e.g. "ETH_USDT" */
  currency_pair: z.string(),
  /** Order side */
  side: z.union([z.literal('buy'), z.literal('sell')]),
  /** Trade role. No value in public endpoints */
  role: z.union([z.literal('maker'), z.literal('taker')]),
  /** Trade amount, e.g. "0.0104" */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Order price, e.g. "1604.3" */
  price: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Related order ID. No value in public endpoints, e.g. "406950140354" */
  order_id: z.string(),
  /** Fee deducted. No value in public endpoints, e.g. "0.03336944" */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Fee currency unit. No value in public endpoints, e.g. "USDT" */
  fee_currency: z.string(),
  /** Points used to deduct fee. No value in public endpoints, e.g. "0" */
  point_fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** GT used to deduct fee. No value in public endpoints, e.g. "0" */
  gt_fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** The custom data that the user remarked when amending the order */
  amend_text: z.string(),
  /** Represents a unique and consecutive trade ID within a single market. It is used to track and identify trades in the specific market, e.g. "980206" */
  sequence_id: z.string(),
})

export type SpotTrade = z.infer<typeof spotTradeSchema>
